import { AdminRouteName } from '../../../CONSTANTS';
import GuaranteesTableRecords from '../../_partials/GuaranteesTableRecords';

const optionalColumn = [
  'datePaid',
  'dateActioned',
];

const optionalColumnLabelFormat = {
  datePaid: 'Date Paid',
  dateActioned: 'Date Actioned',
};

const AllGuarantees = ({ TabsRaw }: any) => (
  <GuaranteesTableRecords
    TabsRaw={TabsRaw}
    optionalColumn={optionalColumn}
    optionalColumnLabelFormat={optionalColumnLabelFormat}
    defaultUrl={AdminRouteName.allMainGuaranteesRoute}
    toggleStorageId="all_guarantees-table-col"
    hasNameAndImage
    permissionName="can-view-all-guarantees-tab"
  />
);
export default AllGuarantees;
